import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles/index';
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const styles = theme => ({
    formControl: {
        minWidth: 120,
        width: '100%',
    },
    baseField: {
        fontWeight: 500,
    },
    description: {
        color: 'grey',
        float: 'right',
        marginLeft: 'auto',
    }
});

class DashboardSelect extends PureComponent {

    render() {
        const {classes, label, options, alias, value, isBaseField} = this.props;

        if (options && value) {
            const isValueFoundInOptions = options.find(x => x.fieldValue === value)
            if (!isValueFoundInOptions) {
                this.props.onChange(alias, '', false)
            }
        }

        return (<>
                {options &&
                <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">{label}</InputLabel>
                    <Select
                        classes={{select: isBaseField ? classes.baseField : null}}
                        value={value}
                        onChange={(event) => this.props.onChange(alias, event.target.value)}
                        inputProps={{
                            name: alias,
                            id: alias,
                        }}
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {options.map((value, key) =>
                            <MenuItem value={value.fieldValue}
                                      className={isBaseField ? classes.baseField : null}>{value.fieldValue}
                                <small className={classes.description}>{value.visitorSessionCount}</small></MenuItem>)}
                    </Select>
                </FormControl>
                }
            </>
        );
    }
}

DashboardSelect.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DashboardSelect);
